import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  surveyContainer: {
    bottom: theme.spacing(2),
    pointerEvents: "all",
    position: "fixed",
    right: theme.spacing(2),
    zIndex: theme.zIndex.modal,
  },
}));
